module.exports = "/_next/static/images/19-a79f5fb4996eee14f17174cbee9aac18.png.webp";